import { apiClient } from "@/lib/api";
import type {
  SellerProfile,
  SellerProfileUpdate,
  SellerWallet,
} from "@/types";

export const sellerService = {
  updateSellerProfile: async (
    userId: string,
    data: SellerProfileUpdate,
  ): Promise<SellerProfile> => {
    const response = await apiClient.patch<SellerProfile>(
      `/users/${userId}/seller-profile`,
      data,
    );
    return response.data;
  },

  getWallet: async (userId: string): Promise<SellerWallet> => {
    const response = await apiClient.get<SellerWallet>(
      `/users/${userId}/wallet`,
    );
    return response.data;
  },
};
